module.exports = __webpack_public_path__ + "img/SH.83cd4340.svg";